import { QueryPathOptions } from "./QueryPathOptions";
import ObjectToString from "./ObjectToString";
/*
query: `[${ctx.elementId}].childobjects(recursive=1, criteria="typename=\\"KPI\\"")`,
*/
export default class QueryPath {
  tag: string;
  options?: Partial<QueryPathOptions> = {};
  filterTypename?: string;
  constructor(tag: string, options?: Partial<QueryPathOptions>) {
    this.tag = tag;
    this.options = options;
  }
  toString() {
    return `${this.tag}${
      this.options ? `(${ObjectToString(this.options)})` : ""
    }`;
  }
}
